(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["lf-home-moods"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('lf-home-moods')) {
  customElements.define('lf-home-moods', class extends HTMLElement {
    connectedCallback() {
      if (this.initialized) return;
      this.initialized = true;
      this.tabs = Array.from(this.querySelectorAll('[role="tab"]'));
      this.panels = Array.from(this.querySelectorAll('[role="tabpanel"]'));
      this.activate = (tab, focus = false) => {
        this.tabs.forEach(item => { const active = item === tab; item.setAttribute('aria-selected', String(active)); item.tabIndex = active ? 0 : -1; item.toggleAttribute('data-active', active); });
        this.panels.forEach(panel => { panel.hidden = panel.id !== tab.getAttribute('aria-controls'); });
        if (focus) tab.focus();
      };
      this.onClick = event => { const tab = event.target.closest('[role="tab"]'); if (tab && this.contains(tab)) this.activate(tab); };
      this.onKey = event => {
        const index = this.tabs.indexOf(event.target);
        if (index < 0 || !['ArrowRight','ArrowLeft','Home','End'].includes(event.key)) return;
        event.preventDefault();
        const next = event.key === 'Home' ? 0 : event.key === 'End' ? this.tabs.length - 1 : (index + (event.key === 'ArrowRight' ? 1 : -1) + this.tabs.length) % this.tabs.length;
        this.activate(this.tabs[next], true);
      };
      this.onHash = () => { const tab = this.tabs.find(item => item.dataset.anchor === window.location.hash.slice(1)); if (tab) { this.activate(tab); this.scrollIntoView({block: 'start'}); } };
      this.onBlock = event => { const panel = event.target.closest('[role="tabpanel"]'); if (panel && this.contains(panel)) { const tab = this.tabs.find(item => item.getAttribute('aria-controls') === panel.id); if (tab) this.activate(tab); } };
      this.addEventListener('click', this.onClick); this.addEventListener('keydown', this.onKey); this.addEventListener('shopify:block:select', this.onBlock); window.addEventListener('hashchange', this.onHash); this.onHash();
    }
    disconnectedCallback() { this.removeEventListener('click', this.onClick); this.removeEventListener('keydown', this.onKey); this.removeEventListener('shopify:block:select', this.onBlock); window.removeEventListener('hashchange', this.onHash); this.initialized = false; }
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["lf-main-collection"]) return;
  try {
    
  if (!customElements.get('lf-collection-tools')) {
    customElements.define('lf-collection-tools', class extends HTMLElement {
      connectedCallback() {
        this.frame = requestAnimationFrame(() => this.setup());
      }
      disconnectedCallback() {
        cancelAnimationFrame(this.frame);
        clearTimeout(this.previewTimer);
        this.request?.abort();
        this.previewRequest?.abort();
        this.events?.abort();
        this.events = null;
        this.finishClose(false);
      }
      setup() {
        if (!this.isConnected || this.events) return;
        this.section = this.closest('[data-lf-collection]');
        this.form = this.querySelector('form');
        this.home = this.querySelector('[data-lf-tools-home]');
        this.dialog = this.querySelector('dialog');
        this.host = this.querySelector('[data-lf-dialog-tools]');
        this.opener = this.querySelector('[data-lf-open-tools]');
        this.closer = this.querySelector('[data-lf-close-tools]');
        this.applyCount = this.querySelector('[data-lf-draft-count]');
        this.draftStatus = this.querySelector('[data-lf-draft-status]');
        this.status = this.section?.querySelector('[data-lf-collection-status]');
        if (!this.section || !this.form) return;
        this.events = new AbortController();
        const options = { signal: this.events.signal };
        this.mobile = matchMedia('(max-width:699px)');
        this.appliedURL = this.cleanURL(location.href).href;
        this.draftPath = this.form.getAttribute('action');
        this.initialCount = this.section.dataset.lfExactSizeError ? null : Number(this.section.dataset.productCount);
        this.previewCount = this.initialCount;
        this.mobile.addEventListener('change', () => this.syncLayout(), options);
        this.opener?.addEventListener('click', () => this.openTools(), options);
        this.closer?.addEventListener('click', () => this.dialog.close(), options);
        this.dialog?.addEventListener('close', () => this.finishClose(true), options);
        this.dialog?.addEventListener('click', (event) => {
          if (event.target !== this.dialog) return;
          const rect = this.dialog.getBoundingClientRect();
          if (event.clientX < rect.left || event.clientX > rect.right || event.clientY < rect.top || event.clientY > rect.bottom) this.dialog.close();
        }, options);
        this.form.addEventListener('input', (event) => {
          if (event.target.matches('input')) this.draftChanged();
        }, options);
        this.form.addEventListener('change', (event) => {
          if (event.target.matches('select')) {
            if (this.dialog?.open) this.draftChanged();
            else this.form.requestSubmit();
          }
        }, options);
        this.form.addEventListener('submit', (event) => {
          event.preventDefault();
          if (this.validationMessage()) {
            this.updateDraft(this.validationMessage(), true);
            this.form.reportValidity();
            return;
          }
          if (this.dialog?.open && (this.previewPending || this.previewCount === 0)) return;
          this.navigate(this.formURL(), { focus: 'results' });
        }, options);
        this.section.addEventListener('click', (event) => this.onClick(event), options);
        window.addEventListener('popstate', (event) => {
          const state = event.state?.lfCollection;
          const target = this.cleanURL(location.href);
          if (target.href === this.appliedURL) {
            if (state?.url === target.href) this.restoreScroll(state);
            return;
          }
          this.navigate(target, { history: false, restore: state, focus: null });
        }, options);
        window.addEventListener('pagehide', () => {
          this.savePosition();
          this.request?.abort();
          this.stopPreview();
          if (this.dialog?.open) this.dialog.close();
          this.finishClose(false);
          history.scrollRestoration = 'auto';
        }, options);
        window.addEventListener('pageshow', (event) => {
          history.scrollRestoration = 'manual';
          if (this.dialog?.open) this.dialog.close();
          this.finishClose(false);
          if (event.persisted) {
            this.form.reset();
            this.draftPath = this.form.getAttribute('action');
            this.previewCount = this.initialCount;
            this.updateDraft();
          }
          this.syncLayout();
          const saved = history.state?.lfCollection;
          if (saved?.url === this.appliedURL) this.restoreScroll(saved);
        }, options);
        history.scrollRestoration = 'manual';
        this.syncLayout();
        this.updateDraft();
        // A breadcrumb return is a new navigation, unlike browser Back. Restore only its one-time record.
        const browseReturn = this.takeBrowseReturn();
        if (browseReturn) {
          try { history.replaceState({ ...history.state, lfCollection: browseReturn }, '', location.href); } catch (error) {}
        }
        // A full return from a product page may create a new document rather than use BFCache.
        const saved = history.state?.lfCollection;
        const partialReplacement = this.section.hasAttribute('data-lf-navigation-replacement');
        this.section.removeAttribute('data-lf-navigation-replacement');
        if (!partialReplacement && saved?.url === this.appliedURL) this.restoreScroll(saved);
        const exactSizeURL = this.exactSizeURL(this.appliedURL);
        if (exactSizeURL.href !== this.appliedURL) {
          const position = saved?.url === this.appliedURL ? saved : { x: scrollX, y: scrollY };
          this.navigate(exactSizeURL, { history: 'replace', restore: { ...position, url: exactSizeURL.href }, focus: null });
        }
      }
      rememberProductContext(target) {
        const match = target.pathname.match(/\/products\/([^/]+)\/?$/i);
        if (!match || target.origin !== location.origin || target.username || target.password) return;
        const position = this.scrollState || { x: scrollX, y: scrollY };
        try {
          sessionStorage.setItem('lfBrowsePendingV1', JSON.stringify({ v: 1, kind: 'collection', url: this.appliedURL,
            target: '/products/' + match[1], from: this.cleanURL(location.href).href, at: Date.now(), x: position.x, y: position.y }));
        } catch (error) {}
      }
      takeBrowseReturn() {
        try {
          const text = sessionStorage.getItem('lfBrowseRestoreV1');
          sessionStorage.removeItem('lfBrowseRestoreV1');
          const value = JSON.parse(text || 'null');
          if (!value || value.v !== 1 || value.kind !== 'collection' || !Number.isFinite(value.at) || Date.now() - value.at < 0 || Date.now() - value.at > 2 * 60 * 1000) return null;
          const url = this.cleanURL(value.url);
          const from = this.cleanURL(value.from);
          if (!document.referrer) return null;
          const referrer = this.cleanURL(document.referrer);
          const product = referrer.pathname.match(/\/products\/([^/]+)\/?$/i);
          if ([url, from, referrer].some((item) => item.origin !== location.origin || item.username || item.password)) return null;
          if (url.href !== this.appliedURL || from.href !== referrer.href || !product || value.target !== '/products/' + product[1]) return null;
          if (![value.x, value.y].every((number) => Number.isFinite(number) && number >= 0 && number <= 10000000)) return null;
          return { url: url.href, x: value.x, y: value.y };
        } catch (error) { return null; }
      }
      cleanURL(value) {
        const url = new URL(value, location.href);
        url.searchParams.delete('section_id');
        url.searchParams.delete('sections');
        url.hash = '';
        return url;
      }
      exactSizeURL(value) {
        const url = this.cleanURL(value);
        const base = new URL(this.section.dataset.collectionUrl, location.href).pathname.replace(/\/$/, '');
        let tags = [];
        if (url.pathname.startsWith(base + '/')) {
          try { tags = decodeURIComponent(url.pathname.slice(base.length + 1)).split('+'); } catch (error) {}
        }
        tags.push(...url.searchParams.getAll('filter.p.tag').flatMap((tag) => tag.split(',')));
        if (tags.some((tag) => /^lf-size-cm-\d+(?:\.\d+)?x\d+(?:\.\d+)?$/.test(tag))) url.searchParams.delete('page');
        return url;
      }
      formURL() {
        const url = this.cleanURL(this.appliedURL);
        url.pathname = new URL(this.draftPath, location.href).pathname;
        for (const key of Array.from(url.searchParams.keys())) {
          if (key.startsWith('filter.') || key === 'sort_by' || key === 'page') url.searchParams.delete(key);
        }
        for (const [key, value] of new FormData(this.form)) {
          if (String(value).trim() !== '') url.searchParams.append(key, value);
        }
        return url;
      }
      linkURL(link) {
        const url = this.cleanURL(this.appliedURL);
        if (link.hasAttribute('data-lf-remove-tag')) {
          url.pathname = new URL(link.href).pathname;
        } else if (link.hasAttribute('data-lf-clear-filters')) {
          url.pathname = new URL(this.section.dataset.collectionUrl, location.href).pathname;
          for (const key of Array.from(url.searchParams.keys())) {
            if (key.startsWith('filter.')) url.searchParams.delete(key);
          }
        } else if (link.hasAttribute('data-lf-remove-price')) {
          for (const key of link.dataset.lfRemovePrice.split('|')) url.searchParams.delete(key);
        } else if (link.hasAttribute('data-lf-remove-filter')) {
          const key = link.dataset.lfRemoveFilter;
          const remaining = url.searchParams.getAll(key).filter((value) => value !== link.dataset.lfRemoveValue);
          url.searchParams.delete(key);
          remaining.forEach((value) => url.searchParams.append(key, value));
        } else {
          return this.cleanURL(link.href);
        }
        url.searchParams.delete('page');
        return url;
      }
      onClick(event) {
        const link = event.target.closest('a');
        if (!link || event.defaultPrevented || event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey || (link.target && link.target !== '_self') || link.hasAttribute('download')) return;
        const url = new URL(link.href);
        if (url.origin !== location.origin) return;
        if (url.pathname.includes('/products/')) {
          this.savePosition();
          this.rememberProductContext(url);
          return;
        }
        if (link.hasAttribute('data-lf-clear-filters') && this.dialog?.open) {
          event.preventDefault();
          this.form.querySelectorAll('input[type=checkbox]').forEach((input) => { input.checked = false; });
          this.form.querySelectorAll('input[type=number]').forEach((input) => { input.value = ''; });
          this.draftPath = this.section.dataset.collectionUrl;
          this.draftChanged();
          return;
        }
        if (!link.matches('[data-lf-remove-tag], [data-lf-remove-filter], [data-lf-remove-price], [data-lf-clear-filters], [data-lf-exact-size-reset], .lf-commerce-pagination a')) return;
        event.preventDefault();
        const chips = Array.from(this.section.querySelectorAll('.lf-collection__active a'));
        const chipIndex = chips.indexOf(link);
        this.navigate(this.linkURL(link), { focus: chipIndex >= 0 ? { chipIndex } : 'results' });
      }
      validationMessage() {
        let message = '';
        this.form.querySelectorAll('.lf-collection__price-filter').forEach((group) => {
          const [min, max] = group.querySelectorAll('input');
          if (!min || !max) return;
          min.setCustomValidity('');
          max.setCustomValidity('');
          if (min.value !== '' && max.value !== '' && Number(min.value) > Number(max.value)) {
            message = 'Minimum price must be less than or equal to maximum price.';
            max.setCustomValidity(message);
          } else if (!min.validity.valid || !max.validity.valid) {
            message = 'Enter a valid price within the available range.';
          }
        });
        return message;
      }
      draftChanged() {
        this.stopPreview();
        this.previewCount = null;
        const error = this.validationMessage();
        if (error) {
          this.updateDraft(error, true);
          return;
        }
        if (!this.dialog?.open) return;
        this.previewPending = true;
        this.updateDraft('Checking matching products…');
        this.previewTimer = setTimeout(() => this.preview(), 300);
      }
      stopPreview() {
        clearTimeout(this.previewTimer);
        this.previewRequest?.abort();
        this.previewRequest = null;
        this.previewPending = false;
      }
      async preview() {
        const request = new AbortController();
        this.previewRequest = request;
        try {
          const section = await this.fetchSection(this.formURL(), request.signal);
          if (request.signal.aborted || this.previewRequest !== request || !this.dialog.open) return;
          if (section.dataset.lfExactSizeError) throw new Error('Exact-size results are incomplete');
          this.previewCount = Number(section.dataset.productCount);
          this.previewPending = false;
          this.updateDraft(this.previewCount === 0 ? 'No products match this combination. Remove a choice or widen the price range.' : '');
        } catch (error) {
          if (request.signal.aborted || this.previewRequest !== request) return;
          this.previewCount = null;
          this.previewPending = false;
          this.updateDraft('Could not check the count. Apply to try loading your results.');
        }
      }
      updateDraft(message = '', invalid = false) {
        const blocked = invalid || this.previewPending || this.previewCount === 0;
        const apply = this.form.querySelector('.lf-collection__dialog-actions button[type=submit]');
        if (apply) apply.disabled = blocked;
        if (this.applyCount) this.applyCount.textContent = this.previewPending ? ' · checking…' : this.previewCount === null ? '' : ' · ' + this.previewCount + (this.previewCount === 1 ? ' product' : ' products');
        if (this.draftStatus) {
          this.draftStatus.textContent = message;
          this.draftStatus.hidden = !message;
        }
      }
      async fetchSection(value, signal) {
        const url = this.cleanURL(value);
        url.searchParams.set('section_id', this.section.dataset.sectionId);
        const controller = new AbortController();
        const abort = () => controller.abort();
        if (signal?.aborted) abort();
        else signal?.addEventListener('abort', abort, { once: true });
        const timeout = setTimeout(abort, 12000);
        try {
          const response = await fetch(url.href, { signal: controller.signal, credentials: 'same-origin', headers: { 'X-Requested-With': 'XMLHttpRequest' } });
          if (!response.ok) throw new Error('Collection request failed');
          const document = new DOMParser().parseFromString(await response.text(), 'text/html');
          const section = Array.from(document.querySelectorAll('[data-lf-collection]')).find((item) => item.dataset.sectionId === this.section.dataset.sectionId);
          if (!section || !section.querySelector('lf-collection-tools') || (!section.querySelector('.lf-commerce-product-grid') && !section.dataset.lfExactSizeError) || (!Number.isFinite(Number(section.dataset.productCount)) && !section.dataset.lfExactSizeError)) throw new Error('Incomplete collection response');
          return section;
        } finally {
          clearTimeout(timeout);
          signal?.removeEventListener('abort', abort);
        }
      }
      async navigate(value, options = {}) {
        const requested = this.cleanURL(value);
        const target = this.exactSizeURL(requested);
        this.request?.abort();
        this.stopPreview();
        if (target.href === this.appliedURL && options.history !== false) {
          if (this.dialog?.open) this.dialog.close();
          return;
        }
        if (options.history !== false) this.savePosition();
        this.committing = true;
        if (this.dialog?.open) this.dialog.close();
        this.finishClose(false);
        const request = new AbortController();
        this.request = request;
        this.section.setAttribute('aria-busy', 'true');
        this.showStatus('Updating products…');
        try {
          const next = await this.fetchSection(target, request.signal);
          if (request.signal.aborted || this.request !== request || !this.isConnected) return;
          const samePath = target.pathname === new URL(this.appliedURL).pathname;
          if (samePath && this.section.querySelector('.lf-topic-guide')?.open) next.querySelector('.lf-topic-guide')?.setAttribute('open', '');
          const title = next.dataset.pageTitle;
          if (options.history === 'replace' || (options.history === false && target.href !== requested.href)) history.replaceState({ ...history.state, lfCollection: { url: target.href, x: 0, y: 0 } }, '', target.href);
          else if (options.history !== false) history.pushState({ ...history.state, lfCollection: { url: target.href, x: 0, y: 0 } }, '', target.href);
          const restore = options.restore && this.exactSizeURL(options.restore.url).href === target.href ? { ...options.restore, url: target.href } : options.restore;
          // The old controller disconnects and the replacement creates its own listeners.
          next.setAttribute('data-lf-navigation-replacement', '');
          this.section.replaceWith(next);
          if (title) document.title = title;
          const canonical = document.querySelector('link[rel=canonical]');
          if (canonical) canonical.href = target.origin + target.pathname;
          requestAnimationFrame(() => {
            if (!next.isConnected) return;
            const message = next.querySelector('[data-lf-collection-status]');
            if (message) {
              message.hidden = false;
              message.classList.add('lf-visually-hidden');
              message.textContent = next.dataset.lfExactSizeError ? 'Exact-size results could not be calculated. Adjust or clear your filters.' : next.dataset.productCount + ' products shown.';
            }
            if (restore?.url === target.href) {
              window.scrollTo({ left: restore.x || 0, top: restore.y || 0, behavior: 'instant' });
            } else {
              let focus;
              if (options.focus && typeof options.focus === 'object') {
                const chips = next.querySelectorAll('.lf-collection__active a');
                focus = chips[Math.min(options.focus.chipIndex, chips.length - 1)];
              }
              if (!focus && options.focus) focus = next.querySelector(matchMedia('(max-width:699px)').matches ? '[data-lf-open-tools]' : '[data-lf-results-count]');
              if (focus) {
                focus.focus({ preventScroll: true });
                const top = focus.getBoundingClientRect().top;
                if (top < 0 || top > innerHeight - 80) focus.scrollIntoView({ block: 'start', behavior: 'instant' });
              }
            }
            const oldState = history.state || {};
            history.replaceState({ ...oldState, lfCollection: { url: target.href, x: scrollX, y: scrollY } }, '', target.href);
          });
        } catch (error) {
          if (request.signal.aborted || this.request !== request) return;
          this.section.removeAttribute('aria-busy');
          this.committing = false;
          this.form.reset();
          this.form.querySelectorAll('input').forEach((input) => input.setCustomValidity(''));
          this.draftPath = this.form.getAttribute('action');
          this.previewCount = this.initialCount;
          this.updateDraft();
          this.showStatus('We could not update the products. ', target);
        }
      }
      showStatus(message, fallbackURL) {
        if (!this.status) return;
        this.status.replaceChildren(document.createTextNode(message));
        this.status.hidden = false;
        this.status.classList.toggle('lf-visually-hidden', !fallbackURL);
        if (fallbackURL) {
          const link = document.createElement('a');
          link.href = fallbackURL.href;
          link.textContent = 'Load this selection';
          this.status.append(link);
          this.status.tabIndex = -1;
          this.status.focus({ preventScroll: true });
          this.status.scrollIntoView({ block: 'nearest', behavior: 'instant' });
        }
      }
      savePosition() {
        if (this.cleanURL(location.href).href !== this.appliedURL) return;
        const position = this.scrollState || { x: scrollX, y: scrollY };
        history.replaceState({ ...history.state, lfCollection: { url: this.appliedURL, x: position.x, y: position.y } }, '', location.href);
      }
      restoreScroll(saved) {
        requestAnimationFrame(() => requestAnimationFrame(() => {
          if (this.isConnected && this.cleanURL(location.href).href === saved.url) window.scrollTo({ left: saved.x || 0, top: saved.y || 0, behavior: 'instant' });
        }));
      }
      syncLayout() {
        if (!this.dialog?.showModal) return;
        if (!this.mobile.matches) {
          if (this.dialog.open) this.dialog.close();
          this.finishClose(false);
          this.home.append(this.form);
          this.removeAttribute('data-mobile-ready');
        } else {
          this.host.append(this.form);
          this.setAttribute('data-mobile-ready', '');
        }
      }
      openTools() {
        if (!this.mobile.matches || !this.dialog?.showModal || this.dialog.open) return;
        this.committing = false;
        this.draftPath = this.form.getAttribute('action');
        this.snapshot = Array.from(this.form.elements).map((element) => ({ element, value: element.value, checked: element.checked, disabled: element.disabled }));
        this.detailStates = Array.from(this.form.querySelectorAll('details')).map((element) => ({ element, open: element.open }));
        this.detailStates.forEach(({ element }) => { element.open = true; });
        this.previewCount = this.initialCount;
        this.updateDraft(this.previewCount === 0 ? 'No products match. Clear filters or widen the price range.' : '');
        this.dialog.showModal();
        this.opener.setAttribute('aria-expanded', 'true');
        this.lockScroll();
        this.closer.focus({ preventScroll: true });
      }
      finishClose(returnFocus) {
        this.stopPreview();
        if (this.snapshot && !this.committing) {
          this.snapshot.forEach(({ element, value, checked, disabled }) => {
            element.value = value;
            if (typeof checked === 'boolean') element.checked = checked;
            element.disabled = disabled;
            element.setCustomValidity?.('');
          });
          this.draftPath = this.form.getAttribute('action');
        }
        this.detailStates?.forEach(({ element, open }) => { element.open = open; });
        this.snapshot = null;
        this.detailStates = null;
        this.opener?.setAttribute('aria-expanded', 'false');
        this.unlockScroll();
        if (this.form) {
          this.previewCount = this.initialCount;
          this.updateDraft();
        }
        if (returnFocus && this.mobile?.matches && this.isConnected) this.opener.focus({ preventScroll: true });
      }
      lockScroll() {
        if (this.scrollState) return;
        const body = document.body;
        const properties = ['position', 'top', 'left', 'right', 'width', 'overflow'];
        this.scrollState = { y: window.scrollY, x: window.scrollX, styles: properties.map((key) => [key, body.style.getPropertyValue(key), body.style.getPropertyPriority(key)]) };
        body.style.position = 'fixed';
        body.style.top = '-' + this.scrollState.y + 'px';
        body.style.left = '0';
        body.style.right = '0';
        body.style.width = '100%';
        body.style.overflow = 'hidden';
      }
      unlockScroll() {
        if (!this.scrollState) return;
        const saved = this.scrollState;
        this.scrollState = null;
        saved.styles.forEach(([key, value, priority]) => {
          if (value) document.body.style.setProperty(key, value, priority);
          else document.body.style.removeProperty(key);
        });
        const html = document.documentElement;
        const behavior = html.style.getPropertyValue('scroll-behavior');
        const priority = html.style.getPropertyPriority('scroll-behavior');
        html.style.setProperty('scroll-behavior', 'auto', 'important');
        window.scrollTo(saved.x, saved.y);
        if (behavior) html.style.setProperty('scroll-behavior', behavior, priority);
        else html.style.removeProperty('scroll-behavior');
      }
    });
  }


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["lf-main-product"]) return;
  try {
    
  // A context is created only by an actual same-tab product click, never by guessing from referrer.
  if (!customElements.get('lf-product-return')) {
    customElements.define('lf-product-return', class extends HTMLElement {
      connectedCallback() {
        if (this.events) return;
        this.link = this.querySelector('a');
        if (!this.link) return;
        this.defaultHref = this.link.getAttribute('href');
        this.defaultLabel = this.link.textContent;
        this.events = new AbortController();
        const options = { signal: this.events.signal };
        const current = this.cleanURL(location.href);
        const target = this.productKey(current);
        const pending = this.take('lfBrowsePendingV1');
        const referrer = this.cleanURL(document.referrer);
        if (pending && pending.target === target && referrer && pending.from === referrer.href &&
            (pending.from === pending.url || this.productKey(referrer))) {
          this.context = pending;
        } else {
          const navigation = performance.getEntriesByType?.('navigation')[0]?.type;
          const saved = history.state?.lfProductReturn;
          if ((navigation === 'reload' || navigation === 'back_forward') && saved?.entry === current?.href) {
            const context = this.validate(saved);
            if (context?.target === target) this.context = context;
          }
        }
        this.refreshLink();
        if (this.context) {
          try { history.replaceState({ ...history.state, lfProductReturn: { ...this.context, entry: current.href } }, '', location.href); } catch (error) {}
        }
        document.addEventListener('click', (event) => this.onClick(event), options);
        document.addEventListener('submit', (event) => this.onSubmit(event), options);
        window.addEventListener('pageshow', () => this.refreshLink(), options);
      }
      disconnectedCallback() {
        this.events?.abort();
        this.events = null;
      }
      cleanURL(value) {
        if (typeof value !== 'string' || !value) return null;
        try {
          const url = new URL(value, location.href);
          if (url.origin !== location.origin || url.username || url.password) return null;
          url.searchParams.delete('section_id');
          url.searchParams.delete('sections');
          url.hash = '';
          return url;
        } catch (error) { return null; }
      }
      productKey(url) {
        const match = url?.pathname.match(/\/products\/([^/]+)\/?$/i);
        return match ? '/products/' + match[1] : null;
      }
      validate(value, maxAge = 30 * 60 * 1000) {
        if (!value || value.v !== 1 || !Number.isFinite(value.at) || Date.now() - value.at < 0 || Date.now() - value.at > maxAge) return null;
        const url = this.cleanURL(value.url);
        const from = this.cleanURL(value.from);
        const isCollection = url && /^(?:\/[a-z]{2}(?:-[a-z]{2})?)?\/collections\/[^/]+(?:\/[^/]+)?\/?$/i.test(url.pathname);
        const isSearch = url && /^(?:\/[a-z]{2}(?:-[a-z]{2})?)?\/search\/?$/i.test(url.pathname);
        if (!from || (!isCollection && !isSearch) || (value.kind === 'collection' ? !isCollection : value.kind === 'search' ? !isSearch : true)) return null;
        if (typeof value.target !== 'string' || !/^\/products\/[^/]+$/.test(value.target)) return null;
        if (value.mode !== undefined && (value.kind !== 'search' || value.mode !== 'native')) return null;
        if (value.mode === 'native' && (!Number.isInteger(value.shown) || value.shown < 1 || value.shown > 10000)) return null;
        if (![value.x, value.y].every((number) => Number.isFinite(number) && number >= 0 && number <= 10000000)) return null;
        return { v: 1, kind: value.kind, url: url.href, target: value.target, from: from.href, at: value.at, x: value.x, y: value.y,
          ...(Number.isInteger(value.shown) && value.shown >= 0 && value.shown <= 10000 ? { shown: value.shown } : {}),
          ...(value.mode === 'native' ? { mode: 'native' } : {}) };
      }
      take(key) {
        try {
          const text = sessionStorage.getItem(key);
          sessionStorage.removeItem(key);
          return this.validate(JSON.parse(text || 'null'));
        } catch (error) { return null; }
      }
      refreshLink() {
        this.context = this.validate(this.context);
        this.link.href = this.context?.url || this.defaultHref;
        this.link.textContent = this.context ? (this.context.kind === 'search' ? 'Back to search results' : 'Back to collection') : this.defaultLabel;
      }
      ordinaryClick(event, link) {
        return !event.defaultPrevented && event.button === 0 && !event.metaKey && !event.ctrlKey && !event.shiftKey && !event.altKey &&
          (!link.target || link.target === '_self') && !link.hasAttribute('download');
      }
      rememberTarget(target) {
        const context = this.validate(this.context);
        const from = this.cleanURL(location.href);
        const key = this.productKey(target);
        if (!context || !from || !key) return;
        try { sessionStorage.setItem('lfBrowsePendingV1', JSON.stringify({ ...context, target: key, from: from.href, at: Date.now() })); } catch (error) {}
      }
      onClick(event) {
        const link = event.target.closest?.('a');
        if (!link) return;
        if (link === this.link) {
          this.refreshLink();
          if (!this.context || !this.ordinaryClick(event, link)) return;
          const from = this.cleanURL(location.href);
          if (!from) return;
          try { sessionStorage.setItem('lfBrowseRestoreV1', JSON.stringify({ ...this.context, target: this.productKey(from), from: from.href, at: Date.now() })); } catch (error) {}
          return; // Follow the validated href normally; never history.back() across an unknown page.
        }
        if (!this.ordinaryClick(event, link)) return;
        const target = this.cleanURL(link.href);
        if (target && this.productKey(target)) this.rememberTarget(target);
      }
      onSubmit(event) {
        const form = event.target;
        if (event.defaultPrevented || !form.matches?.('[data-lf-variant-form]') || form.method.toLowerCase() !== 'get') return;
        const target = this.cleanURL(form.action);
        if (target && this.productKey(target)) this.rememberTarget(target);
      }
    });
  }
  if (!customElements.get('lf-product-gallery')) {
    customElements.define('lf-product-gallery', class extends HTMLElement {
      connectedCallback() {
        this.setupFrame = requestAnimationFrame(() => this.setupGallery());
      }
      disconnectedCallback() {
        cancelAnimationFrame(this.setupFrame);
        this.events?.abort();
        this.resizeObserver?.disconnect();
        this.events = null;
        this.drag = null;
      }
      setupGallery() {
        if (!this.isConnected || this.events) return;
        this.viewport = this.querySelector('[data-lf-gallery-viewport]');
        this.slides = Array.from(this.querySelectorAll('[data-lf-gallery-slide]'));
        if (!this.viewport || !this.slides.length) return;
        this.thumbnails = this.querySelector('[data-lf-gallery-thumbnails]');
        this.thumbs = Array.from(this.thumbnails?.querySelectorAll('a[data-media-id]') || []);
        this.previous = this.querySelector('[data-lf-gallery-prev]');
        this.next = this.querySelector('[data-lf-gallery-next]');
        this.count = this.querySelector('[data-lf-gallery-count]');
        this.events = new AbortController();
        const options = { signal: this.events.signal };
        this.viewport.addEventListener('scroll', () => {
          if (this.viewport.clientWidth) this.updateSelection(Math.round(this.viewport.scrollLeft / this.viewport.clientWidth));
        }, { ...options, passive: true });
        this.viewport.addEventListener('keydown', (event) => {
          if (event.target !== this.viewport) return;
          let index;
          if (event.key === 'ArrowLeft') index = this.active - 1;
          else if (event.key === 'ArrowRight') index = this.active + 1;
          else if (event.key === 'Home') index = 0;
          else if (event.key === 'End') index = this.slides.length - 1;
          else return;
          event.preventDefault();
          this.selectImage(index);
        }, options);
        this.previous?.addEventListener('click', () => this.selectImage(this.active - 1), options);
        this.next?.addEventListener('click', () => this.selectImage(this.active + 1), options);
        this.thumbs.forEach((thumb) => thumb.addEventListener('click', (event) => {
          const index = this.slides.findIndex((slide) => slide.dataset.mediaId === thumb.dataset.mediaId);
          if (index < 0) return;
          event.preventDefault();
          this.selectImage(index);
        }, options));
        this.viewport.addEventListener('pointerdown', (event) => {
          // Touch and trackpad gestures remain entirely native. Media controls keep their own input.
          if (event.pointerType !== 'mouse' || event.button !== 0 || this.slides.length < 2) return;
          if (event.target.closest('video, iframe, model-viewer, button, input, select, textarea, a')) return;
          this.drag = { id: event.pointerId, x: event.clientX, left: this.viewport.scrollLeft };
          this.viewport.setAttribute('data-dragging', '');
          this.viewport.setPointerCapture(event.pointerId);
        }, options);
        this.viewport.addEventListener('pointermove', (event) => {
          if (!this.drag || this.drag.id !== event.pointerId) return;
          event.preventDefault();
          this.viewport.scrollLeft = this.drag.left + this.drag.x - event.clientX;
        }, options);
        const finishDrag = (event) => {
          if (!this.drag || this.drag.id !== event.pointerId) return;
          const index = this.viewport.clientWidth ? Math.round(this.viewport.scrollLeft / this.viewport.clientWidth) : this.active;
          this.drag = null;
          this.viewport.removeAttribute('data-dragging');
          if (this.viewport.hasPointerCapture(event.pointerId)) this.viewport.releasePointerCapture(event.pointerId);
          this.selectImage(index);
        };
        ['pointerup', 'pointercancel', 'lostpointercapture'].forEach((type) => this.viewport.addEventListener(type, finishDrag, options));
        this.width = this.viewport.clientWidth;
        this.resizeObserver = new ResizeObserver(() => {
          if (this.width === this.viewport.clientWidth) return;
          this.width = this.viewport.clientWidth;
          this.viewport.scrollTo({ left: this.active * this.width, behavior: 'instant' });
        });
        this.resizeObserver.observe(this.viewport);
        this.updateSelection(this.width ? Math.round(this.viewport.scrollLeft / this.width) : 0);
        this.setAttribute('data-ready', '');
      }
      selectImage(index) {
        const bounded = Math.max(0, Math.min(this.slides.length - 1, index));
        this.viewport.scrollTo({ left: bounded * this.viewport.clientWidth, behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth' });
      }
      updateSelection(index) {
        const bounded = Math.max(0, Math.min(this.slides.length - 1, index));
        if (bounded === this.active) return;
        this.active = bounded;
        if (this.count) this.count.textContent = `${bounded + 1} / ${this.slides.length}`;
        if (this.previous) this.previous.disabled = bounded === 0;
        if (this.next) this.next.disabled = bounded === this.slides.length - 1;
        this.slides.forEach((slide, slideIndex) => {
          slide.setAttribute('aria-hidden', String(slideIndex !== bounded));
          slide.inert = slideIndex !== bounded;
          if (slideIndex !== bounded) slide.querySelectorAll('video').forEach((video) => video.pause());
        });
        const selectedId = this.slides[bounded].dataset.mediaId;
        this.thumbs.forEach((thumb) => {
          if (thumb.dataset.mediaId === selectedId) thumb.setAttribute('aria-current', 'true');
          else thumb.removeAttribute('aria-current');
        });
        const thumb = this.thumbs.find((item) => item.dataset.mediaId === selectedId);
        if (this.thumbnails && thumb && this.thumbnails.scrollWidth > this.thumbnails.clientWidth) {
          if (thumb.offsetLeft < this.thumbnails.scrollLeft) this.thumbnails.scrollLeft = thumb.offsetLeft;
          else if (thumb.offsetLeft + thumb.offsetWidth > this.thumbnails.scrollLeft + this.thumbnails.clientWidth) this.thumbnails.scrollLeft = thumb.offsetLeft + thumb.offsetWidth - this.thumbnails.clientWidth;
        }
      }
    });
  }

  if (!customElements.get('lf-style-options')) {
    customElements.define('lf-style-options', class extends HTMLElement {
      connectedCallback() {
        this.setupFrame = requestAnimationFrame(() => {
          this.list = this.querySelector('[data-lf-style-list]');
          this.selected = this.list?.querySelector('[aria-current=true]');
          if (!this.list || !this.selected) return;
          this.revealSelection();
          this.resizeObserver = new ResizeObserver(() => this.revealSelection());
          this.resizeObserver.observe(this.list);
        });
      }
      disconnectedCallback() {
        cancelAnimationFrame(this.setupFrame);
        this.resizeObserver?.disconnect();
      }
      revealSelection() {
        if (!this.list || !this.selected || this.list.scrollWidth <= this.list.clientWidth) return;
        const listRect = this.list.getBoundingClientRect();
        const selectedRect = this.selected.getBoundingClientRect();
        if (selectedRect.left < listRect.left) this.list.scrollLeft += selectedRect.left - listRect.left - 3;
        else if (selectedRect.right > listRect.right) this.list.scrollLeft += selectedRect.right - listRect.right + 3;
      }
    });
  }

  document.addEventListener('change', function(event) {
    if (event.target.matches('[data-lf-variant-form] select')) event.target.form.requestSubmit();
  });
  if (!customElements.get('lf-mobile-purchase')) {
    customElements.define('lf-mobile-purchase', class extends HTMLElement {
      connectedCallback() {
        this.setupFrame = requestAnimationFrame(() => this.setup());
      }
      disconnectedCallback() {
        cancelAnimationFrame(this.setupFrame);
        cancelAnimationFrame(this.updateFrame);
        this.events?.abort();
        this.errorsObserver?.disconnect();
        this.resizeObserver?.disconnect();
        this.events = null;
        this.hidden = true;
      }
      setup() {
        if (!this.isConnected || this.events) return;
        this.section = this.closest('.lf-pdp');
        this.purchase = this.section.querySelector('.lf-pdp__purchase');
        this.form = this.section.querySelector('.lf-pdp__form');
        this.styleOptions = this.section.querySelector('[data-lf-style-options]');
        this.styleList = this.styleOptions?.querySelector('[data-lf-style-list]');
        this.variantForm = this.section.querySelector('[data-lf-variant-form]');
        this.variantSelect = this.variantForm?.querySelector('select[name=variant]');
        this.variantInput = this.form?.querySelector('input[name=id]');
        this.mainButton = this.form?.querySelector('button[name=add]');
        this.button = this.querySelector('button');
        this.label = this.querySelector('[data-lf-sticky-label]');
        this.summary = this.querySelector('[data-lf-sticky-summary]');
        if (!this.form?.requestSubmit || !this.variantInput || !this.mainButton || !this.button) return;
        this.events = new AbortController();
        const options = { signal: this.events.signal };
        this.mobile = matchMedia('(max-width:699px)');
        this.available = this.dataset.available === 'true';
        this.explicitVariant = new URL(window.location.href).searchParams.get('variant') === this.variantInput.value;
        this.needsChoice = this.dataset.multipleVariants === 'true' && !this.explicitVariant;
        this.section.classList.add('lf-pdp--enhanced');
        this.label.textContent = this.needsChoice ? 'Choose options' : this.dataset.addLabel;
        this.summary.textContent = this.needsChoice ? 'Select your size or style' : this.dataset.variantLabel;
        const schedule = () => this.scheduleUpdate();
        window.addEventListener('scroll', schedule, { ...options, passive: true });
        window.addEventListener('resize', schedule, options);
        document.addEventListener('focusin', schedule, options);
        document.addEventListener('focusout', schedule, options);
        this.mobile.addEventListener('change', schedule, options);
        window.addEventListener('pageshow', (event) => {
          this.submitting = false;
          // Restore the choice rendered with this page's price, images and hidden ID.
          if (event.persisted && this.variantSelect) this.variantSelect.value = this.variantInput.value;
          this.pendingVariant = this.variantMismatch();
          this.mainButton.disabled = !this.available || this.pendingVariant;
          this.scheduleUpdate();
        }, options);
        window.addEventListener('pagehide', () => { this.hidden = true; }, options);
        this.variantSelect?.addEventListener('change', () => {
          // A variant GET must finish before the product form can submit a new choice.
          this.pendingVariant = true;
          this.mainButton.disabled = true;
          this.hidden = true;
          this.button.disabled = true;
        }, { ...options, capture: true });
        this.variantForm?.addEventListener('submit', () => {
          this.pendingVariant = true;
          this.mainButton.disabled = true;
          this.hidden = true;
        }, options);
        this.form.addEventListener('submit', (event) => {
          if (this.pendingVariant || this.variantMismatch()) {
            event.preventDefault();
            this.hidden = true;
            this.chooseOption();
            return;
          }
          // Keep the native submitter enabled so Shopify receives the original form.
          this.submitting = true;
          this.hidden = true;
          this.button.disabled = true;
        }, { ...options, capture: true });
        this.form.addEventListener('invalid', () => { this.hidden = true; }, { ...options, capture: true });
        this.form.addEventListener('input', schedule, options);
        this.button.addEventListener('click', () => {
          if (this.pendingVariant || this.variantMismatch() || this.submitting) {
            this.hidden = true;
            this.chooseOption();
            return;
          }
          if (this.needsChoice) {
            this.chooseOption();
            return;
          }
          if (!this.available || this.mainButton.disabled || this.hasError()) return;
          if (!this.form.checkValidity()) {
            this.hidden = true;
            this.purchase.scrollIntoView({ behavior: 'instant', block: 'center' });
            this.form.reportValidity();
            return;
          }
          this.form.requestSubmit(this.mainButton);
        }, options);
        this.errorsObserver = new MutationObserver(schedule);
        this.errorsObserver.observe(this.form, { childList: true, subtree: true, characterData: true });
        this.resizeObserver = new ResizeObserver(schedule);
        this.resizeObserver.observe(this.purchase);
        this.resizeObserver.observe(this.section);
        this.pendingVariant = this.variantMismatch();
        if (this.pendingVariant) this.mainButton.disabled = true;
        this.scheduleUpdate();
      }
      variantMismatch() {
        return Boolean(this.variantSelect && this.variantSelect.value !== this.variantInput.value);
      }
      hasError() {
        return Boolean(this.form.querySelector('[data-lf-purchase-errors], .errors, [aria-invalid=true], :invalid'));
      }
      chooseOption() {
        const target = this.styleList?.querySelector('[aria-current=true]') || this.variantSelect || this.mainButton;
        const group = this.styleOptions || this.purchase;
        group.scrollIntoView({ behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth', block: 'center' });
        target.focus({ preventScroll: true });
      }
      scheduleUpdate() {
        if (this.updateFrame) return;
        this.updateFrame = requestAnimationFrame(() => {
          this.updateFrame = null;
          this.updateVisibility();
        });
      }
      updateVisibility() {
        if (this.needsChoice && this.styleList) {
          const bounds = this.styleList.getBoundingClientRect();
          const headerBottom = document.querySelector('header')?.getBoundingClientRect().bottom || 0;
          if (bounds.top >= Math.max(0, headerBottom) + 8 && bounds.bottom <= window.innerHeight - 88) {
            this.needsChoice = false;
            this.label.textContent = this.dataset.addLabel;
            this.summary.textContent = this.dataset.variantLabel;
          }
        }
        const passedPurchase = this.purchase.getBoundingClientRect().bottom <= 0;
        const withinProduct = this.section.getBoundingClientRect().bottom > 100;
        const focusedInput = document.activeElement?.matches('input, select, textarea, [contenteditable=true]');
        const safe = !this.pendingVariant && !this.variantMismatch() && !this.submitting && !this.hasError();
        this.hidden = !(this.mobile.matches && passedPurchase && withinProduct && safe && this.available && !focusedInput);
        this.button.disabled = !safe || !this.available;
      }
    });
  }


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["lf-size-guide"] && !Shopify.designMode) return;
  try {
    
(() => {
function floorTransform(tile) {
    const source = [[0, 0], [60, 0], [60, 60], [0, 60]];
    const rows = [];
    source.forEach(([x, y], i) => {
        const { x: u, y: v } = tile[i];
        rows.push([x, y, 1, 0, 0, 0, -u * x, -u * y, u]);
        rows.push([0, 0, 0, x, y, 1, -v * x, -v * y, v]);
    });
    for (let c = 0; c < 8; c++) {
        let pivot = c;
        for (let r = c + 1; r < 8; r++)
            if (Math.abs(rows[r][c]) > Math.abs(rows[pivot][c]))
                pivot = r;
        [rows[c], rows[pivot]] = [rows[pivot], rows[c]];
        const divisor = rows[c][c];
        if (Math.abs(divisor) < 1e-10)
            throw new Error('Invalid floor calibration');
        for (let j = c; j <= 8; j++)
            rows[c][j] /= divisor;
        for (let r = 0; r < 8; r++)
            if (r !== c) {
                const factor = rows[r][c];
                for (let j = c; j <= 8; j++)
                    rows[r][j] -= factor * rows[c][j];
            }
    }
    const h = rows.map(r => r[8]);
    return ({ x, y }) => {
        const denominator = h[6] * x + h[7] * y + 1;
        return { x: (h[0] * x + h[1] * y + h[2]) / denominator, y: (h[3] * x + h[4] * y + h[5]) / denominator };
    };
}
function sceneFootprint(scene, size) {
    const anchor = scene.compactAnchor && size.long <= 80 ? scene.compactAnchor : scene.anchor;
    const width = scene.alongDepth ? size.short : size.long;
    const height = scene.alongDepth ? size.long : size.short;
    const round = size.shape === 'round';
    return {
        x: scene.alongDepth ? anchor.x + (round ? 40 - width / 2 : 0) : anchor.x - width / 2,
        y: scene.alongDepth ? anchor.y - height / 2 : anchor.y + (round ? 40 - height / 2 : 0),
        width, height,
    };
}
function outlinePoints(scene, size) {
    const { x, y, width, height } = sceneFootprint(scene, size);
    if (size.shape === 'rectangle') {
        const radius = Math.min(size.cornerRadius || 0, width / 2, height / 2);
        if (!radius)
            return [{ x, y }, { x: x + width, y }, { x: x + width, y: y + height }, { x, y: y + height }];
        const centers = [{ x: x + width - radius, y: y + radius }, { x: x + width - radius, y: y + height - radius }, { x: x + radius, y: y + height - radius }, { x: x + radius, y: y + radius }];
        return centers.flatMap((center, i) => Array.from({ length: 9 }, (_, j) => {
            const angle = (-90 + i * 90 + j / 8 * 90) * Math.PI / 180;
            return { x: center.x + radius * Math.cos(angle), y: center.y + radius * Math.sin(angle) };
        }));
    }
    return Array.from({ length: 80 }, (_, i) => {
        const angle = i / 80 * Math.PI * 2;
        return { x: x + width / 2 + Math.cos(angle) * width / 2, y: y + height / 2 + Math.sin(angle) * height / 2 };
    });
}
function measurementLine(a, b, offset = 28) {
    const length = Math.hypot(b.x - a.x, b.y - a.y);
    const normal = { x: -(b.y - a.y) / length, y: (b.x - a.x) / length };
    const move = (p, d) => ({ x: p.x + normal.x * d, y: p.y + normal.y * d });
    return { a: move(a, offset), b: move(b, offset), from: a, to: b, label: move({ x: (a.x + b.x) / 2, y: (a.y + b.y) / 2 }, offset + 12), normal };
}

const escapeHtml = value => String(value).replace(/[&<>"']/g, char => ({'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;',"'":'&#39;'}[char]));
const points = values => values.map(p => p.x + ',' + p.y).join(' ');
class LivingfunSizeGuide extends HTMLElement {
  connectedCallback() {
    if (this.initialized) return;
    this.initialized = true;
    this.data = JSON.parse(this.querySelector('[data-size-config]').textContent);
    this.selected = '50x80'; this.room = 'tub'; this.compare = false;
    this.inchLabels = new Map();
    this.data.masterSizes.forEach(s => { this.inchLabels.set(s.short, s.usShort); this.inchLabels.set(s.long, s.usLong); });
    this.addEventListener('click', event => {
      const roomButton = event.target.closest('[data-room]');
      const sizeButton = event.target.closest('[data-size]');
      if (roomButton) { this.room = roomButton.dataset.room; this.update(); }
      if (sizeButton) { this.selected = sizeButton.dataset.size; this.update(); }
    });
    this.querySelector('[data-compare]').addEventListener('change', event => { this.compare = event.target.checked; this.update(); });
    this.querySelector('[role="tablist"]').addEventListener('keydown', event => {
      const buttons = [...this.querySelectorAll('[data-room]')];
      let index = buttons.findIndex(b => b === document.activeElement);
      if (index < 0) return;
      if (event.key === 'ArrowRight') index = (index + 1) % buttons.length;
      else if (event.key === 'ArrowLeft') index = (index + buttons.length - 1) % buttons.length;
      else if (event.key === 'Home') index = 0;
      else if (event.key === 'End') index = buttons.length - 1;
      else return;
      event.preventDefault(); this.room = buttons[index].dataset.room; this.update(); buttons[index].focus();
    });
    this.update();
  }
  inches(cm) { return String(this.inchLabels.get(cm) ?? Math.round(cm / 2.54 * 10) / 10); }
  us(size) { return size.shape === 'round' ? this.inches(size.short) + '″ ' + this.data.words.diameter : this.inches(size.short) + '″ × ' + this.inches(size.long) + '″'; }
  cm(size) { return size.shape === 'round' ? 'Ø ' + size.short + ' cm' : size.short + ' × ' + size.long + ' cm'; }
  sceneMarkup(room, size, compare = false, compact = false) {
    const scene = this.data.scenes[room], project = floorTransform(scene.tile), m = sceneFootprint(scene,size), height = 1000 * scene.height / scene.width;
    const corners = [{x:m.x,y:m.y},{x:m.x+m.width,y:m.y},{x:m.x+m.width,y:m.y+m.height},{x:m.x,y:m.y+m.height}].map(project);
    const dimensions = size.shape === 'round'
      ? [{...measurementLine(project({x:m.x,y:m.y+m.height/2}),project({x:m.x+m.width,y:m.y+m.height/2}),0),cm:size.short,diameter:true}]
      : [{...measurementLine(corners[3],corners[2],30),cm:m.width,diameter:false},{...measurementLine(room === 'bed' ? corners[2] : corners[0],room === 'bed' ? corners[1] : corners[3],30),cm:m.height,diameter:false}];
    const gradient = this.id + '-' + room + '-' + (compact ? 'compact' : 'main');
    const comparison = compare ? this.data.sizes.filter(s => s.id !== size.id && ((s.shape === 'round') === (size.shape === 'round'))).map(s => '<polygon points="' + points(outlinePoints(scene,s).map(project)) + '" class="sg-scene-comparison"/>').join('') : '';
    const measures = dimensions.map(line => '<g class="sg-scene-dimension">' + (line.diameter ? '' : '<path class="sg-witness" d="M' + line.from.x + ',' + line.from.y + ' L' + (line.a.x+line.normal.x*7) + ',' + (line.a.y+line.normal.y*7) + ' M' + line.to.x + ',' + line.to.y + ' L' + (line.b.x+line.normal.x*7) + ',' + (line.b.y+line.normal.y*7) + '"/>') + '<path d="M' + line.a.x + ',' + line.a.y + ' L' + line.b.x + ',' + line.b.y + '"/>' + [line.a,line.b].map(p => '<path d="M' + (p.x-line.normal.x*5) + ',' + (p.y-line.normal.y*5) + ' l' + (line.normal.x*10) + ',' + (line.normal.y*10) + '"/>').join('') + '</g>').join('');
    const labels = dimensions.map((line,i) => {
      const left = i === 1 ? (room === 'bed' ? 'clamp(12px, ' + (line.label.x/10) + '%, calc(100% - 68px))' : 'clamp(68px, ' + (line.label.x/10) + '%, calc(100% - 12px))') : Math.max(10,Math.min(90,line.label.x/10)) + '%';
      return '<span class="sg-scene-label' + (i === 1 ? ' is-depth' + (room === 'bed' ? ' is-right' : '') : '') + '" style="left:' + left + ';top:' + Math.max(8,Math.min(92,line.label.y/height*100)) + '%"><strong>' + (line.diameter ? 'Ø ' : '') + this.inches(line.cm) + '″</strong><small>' + (line.diameter ? 'Ø ' : '') + line.cm + ' cm</small></span>';
    }).join('');
    const description = size.label + ', ' + this.data.words.approximation + ' ' + this.us(size) + ', ' + this.cm(size) + '. ' + this.data.words.ariaScene;
    return '<div class="sg-room-scene' + (compact ? ' is-compact' : '') + '" style="aspect-ratio:' + scene.width + '/' + scene.height + '"><img src="' + escapeHtml(scene.image) + '" alt="" width="' + scene.width + '" height="' + scene.height + '" loading="' + (compact ? 'lazy' : 'eager') + '"><svg viewBox="0 0 1000 ' + height + '" role="img" aria-label="' + escapeHtml(description) + '"><defs><linearGradient id="' + gradient + '" x1="0" x2=".5" y1="0" y2="1"><stop offset="0" stop-color="#7284ca"/><stop offset="1" stop-color="#4259b0"/></linearGradient></defs>' + comparison + '<polygon points="' + points(outlinePoints(scene,size).map(project)) + '" fill="url(#' + gradient + ')" class="sg-scene-mat"/>' + measures + '</svg>' + labels + '</div>';
  }
  shopUrl(size) {
    const tags = ['lf-size-cm-' + size.short + 'x' + size.long];
    if (size.shape === 'round') tags.unshift('lf-shape-round');
    return this.dataset.productsUrl.replace(/\/$/, '') + '/' + tags.join('+');
  }
  update() {
    const size = this.data.sizes.find(s => s.id === this.selected), room = this.data.rooms.find(r => r.id === this.room), placement = room.placements[size.id];
    this.querySelectorAll('[data-room]').forEach(b => { const active = b.dataset.room === this.room; b.setAttribute('aria-selected',String(active)); b.tabIndex = active ? 0 : -1; b.toggleAttribute('data-active',active); });
    this.querySelector('[role="tabpanel"]').setAttribute('aria-labelledby', this.querySelector('[data-room="' + this.room + '"]').id);
    this.querySelectorAll('[data-size]').forEach(b => b.setAttribute('aria-pressed',String(b.dataset.size === size.id)));
    const text = (selector,value) => this.querySelector(selector).textContent = value;
    text('[data-current-room]',room.label); text('[data-current-us]',this.us(size)); text('[data-current-cm]',this.cm(size));
    text('[data-placement-eyebrow]',size.label + ' / ' + room.label); text('[data-placement-us]',this.us(size)); text('[data-placement-cm]',this.cm(size));
    text('[data-character]',size.character); text('[data-placement-note]',placement.note); text('[data-instruction]',placement.instruction); text('[data-across-us]',this.us(size));
    this.querySelector('[data-shop-size]').href = this.shopUrl(size);
    this.querySelector('[data-benefits]').innerHTML = size.benefits.map(b => '<li><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.7" aria-hidden="true"><path d="m5 12 4 4L19 6"/></svg>' + escapeHtml(b) + '</li>').join('');
    this.querySelector('[data-main-scene]').innerHTML = this.sceneMarkup(this.room,size,this.compare);
    this.querySelectorAll('[data-card-scene]').forEach(target => target.innerHTML = this.sceneMarkup(target.dataset.cardScene,size,false,true));
    this.querySelectorAll('[data-card-note]').forEach(target => target.textContent = this.data.rooms.find(r => r.id === target.dataset.cardNote).placements[size.id].note);
  }
}
if (!customElements.get('livingfun-size-guide')) customElements.define('livingfun-size-guide',LivingfunSizeGuide);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["lfx-colors"] && !Shopify.designMode) return;
  try {
    
if(!customElements.get('lfx-color-studio'))customElements.define('lfx-color-studio',class extends HTMLElement{
  connectedCallback(){
    if(this.ready)return;
    this.ready=true;
    this.abort=new AbortController();
    this.tabs=[...this.querySelectorAll('[data-lfx-tab]')];
    this.panels=[...this.querySelectorAll('[data-lfx-panel]')];
    this.galleries=[...this.querySelectorAll('[data-lfx-gallery]')];
    this.expanded=false;
    this.active=this.tabs[0]?.dataset.colorId;
    this.toggle=this.querySelector('[data-lfx-toggle]');
    this.media=matchMedia('(max-width:640px)');
    const signal=this.abort.signal;
    this.addEventListener('click',event=>{
      const tab=event.target.closest('[data-lfx-tab]');
      if(tab)this.select(tab.dataset.colorId);
      if(event.target.closest('[data-lfx-toggle]')){this.expanded=!this.expanded;this.updateTabs();}
      const button=event.target.closest('[data-lfx-prev],[data-lfx-next]');
      if(button&&!button.disabled)this.move(button.closest('[data-lfx-gallery]'),button.hasAttribute('data-lfx-prev')?-1:1);
    },{signal});
    this.addEventListener('keydown',event=>{
      const tab=event.target.closest('[data-lfx-tab]');
      if(tab){
        const visible=this.tabs.filter(item=>!item.hidden);
        let index=visible.indexOf(tab);
        if(event.key==='ArrowRight')index=(index+1)%visible.length;
        else if(event.key==='ArrowLeft')index=(index-1+visible.length)%visible.length;
        else if(event.key==='Home')index=0;
        else if(event.key==='End')index=visible.length-1;
        else return;
        event.preventDefault();this.select(visible[index].dataset.colorId);visible[index].focus();return;
      }
      const gallery=event.target.closest('[data-lfx-gallery]');
      if(gallery&&(event.key==='ArrowLeft'||event.key==='ArrowRight')){
        event.preventDefault();this.move(gallery,event.key==='ArrowLeft'?-1:1);
      }
    },{signal});
    this.addEventListener('focusin',event=>{
      if(!this.media.matches)return;
      const card=event.target.closest('.lfx-color-viewport .lfx-mat a');
      if(card&&card.matches(':focus-visible'))card.scrollIntoView({block:'nearest',inline:'center',behavior:'instant'});
    },{signal});
    this.addEventListener('shopify:block:select',event=>{
      const panel=event.target.closest('[data-lfx-panel]');if(panel)this.select(panel.dataset.lfxPanel);
    },{signal});
    this.onMediaChange=()=>{this.galleries.forEach(gallery=>this.reset(gallery));this.queueSync();};
    this.media.addEventListener('change',this.onMediaChange);
    this.resizeObserver=new ResizeObserver(()=>this.queueSync());
    this.galleries.forEach(gallery=>{
      const viewport=gallery.querySelector('.lfx-color-viewport');
      viewport.addEventListener('scroll',()=>this.sync(gallery),{passive:true,signal});
      this.resizeObserver.observe(viewport);
    });
    this.updateTabs();
    this.galleries.forEach(gallery=>this.reset(gallery));
    this.queueSync();
  }
  disconnectedCallback(){
    this.abort?.abort();this.resizeObserver?.disconnect();
    this.media?.removeEventListener('change',this.onMediaChange);
    if(this.frame)cancelAnimationFrame(this.frame);
    this.frame=0;this.ready=false;
  }
  select(id){
    if(!this.tabs.some(tab=>tab.dataset.colorId===id))return;
    const changed=id!==this.active;
    this.active=id;this.updateTabs();
    if(changed){const panel=this.panels.find(item=>item.dataset.lfxPanel===id);const gallery=panel?.querySelector('[data-lfx-gallery]');if(gallery)this.reset(gallery);}
    this.queueSync();
  }
  updateTabs(){
    this.tabs.forEach(tab=>{
      const active=tab.dataset.colorId===this.active;
      tab.hidden=!this.expanded&&tab.dataset.common!=='true'&&!active;
      tab.setAttribute('aria-selected',String(active));tab.tabIndex=active?0:-1;tab.toggleAttribute('data-active',active);
      const check=tab.querySelector('[data-check]');if(check)check.hidden=!active;
    });
    this.panels.forEach(panel=>panel.hidden=panel.dataset.lfxPanel!==this.active);
    this.toggle.setAttribute('aria-expanded',String(this.expanded));
    this.toggle.querySelector('span').textContent=this.expanded?this.toggle.dataset.collapseLabel:this.toggle.dataset.expandLabel;
    this.toggle.querySelector('svg').classList.toggle('is-open',this.expanded);
  }
  queueSync(){
    if(this.frame)return;
    this.frame=requestAnimationFrame(()=>{this.frame=0;this.galleries.forEach(gallery=>this.sync(gallery));});
  }
  measure(gallery){
    const viewport=gallery.querySelector('.lfx-color-viewport');
    const cards=[...viewport.querySelectorAll('.lfx-mat')];
    const perPage=this.media.matches?1:3;
    const step=perPage===3?viewport.clientWidth:(cards[0]?.getBoundingClientRect().width||viewport.clientWidth)+(parseFloat(getComputedStyle(viewport).columnGap)||0);
    return {viewport,cards,perPage,step:Math.max(step,1)};
  }
  reset(gallery){gallery.querySelector('.lfx-color-viewport').scrollTo({left:0,behavior:'instant'});this.sync(gallery);}
  move(gallery,direction){
    const {viewport,step}=this.measure(gallery);
    const index=Math.round(viewport.scrollLeft/step);
    viewport.scrollTo({left:(index+direction)*step,behavior:matchMedia('(prefers-reduced-motion: reduce)').matches?'instant':'smooth'});
  }
  sync(gallery){
    if(gallery.closest('[data-lfx-panel]').hidden)return;
    const {viewport,cards,perPage,step}=this.measure(gallery);
    if(!viewport.clientWidth)return;
    const total=cards.length;
    const first=total?Math.min(total-1,Math.round(viewport.scrollLeft/step)*perPage):0;
    const previous=gallery.querySelector('[data-lfx-prev]'),next=gallery.querySelector('[data-lfx-next]');
    previous.hidden=next.hidden=total<=perPage;
    previous.disabled=viewport.scrollLeft<2;
    next.disabled=viewport.scrollLeft>=viewport.scrollWidth-viewport.clientWidth-2;
    gallery.querySelector('[data-lfx-range]').textContent=gallery.dataset.statusTemplate.replace('[first]',String(total?first+1:0)).replace('[last]',String(Math.min(first+perPage,total))).replace('[total]',String(total));
  }
});


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["lfx-garden"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('lfx-garden-carousel')) {
    class LfxGardenCarousel extends HTMLElement {
      connectedCallback() {
        if (this.controller) return;
        this.viewport = this.querySelector('[data-garden-viewport]');
        this.slides = [...this.querySelectorAll('[data-garden-slide]')];
        if (!this.viewport || !this.slides.length) return;
        this.status = this.querySelector('[data-garden-status]');
        this.activeIndex = 0;
        this.controller = new AbortController();
        const options = { signal: this.controller.signal };
        this.viewport.addEventListener('pointerdown', event => {
          this.gesture = { id: event.pointerId, x: event.clientX, y: event.clientY };
          this.suppressClickUntil = 0;
        }, { ...options, passive: true });
        this.viewport.addEventListener('pointermove', event => {
          if (this.gesture?.id !== event.pointerId) return;
          if (Math.hypot(event.clientX - this.gesture.x, event.clientY - this.gesture.y) > 8) this.suppressClickUntil = performance.now() + 500;
        }, { ...options, passive: true });
        const endGesture = () => { this.gesture = null; };
        ['pointerup', 'pointercancel'].forEach(type => this.viewport.addEventListener(type, endGesture, { ...options, passive: true }));
        this.viewport.addEventListener('click', event => {
          if (event.detail !== 0 && performance.now() < (this.suppressClickUntil || 0) && event.target.closest('[data-garden-product]')) event.preventDefault();
        }, options);

        this.addEventListener('click', event => {
          const button = event.target.closest('button');
          if (!button || !this.contains(button)) return;
          if (button.hasAttribute('data-garden-previous')) this.goTo(this.activeIndex - 1);
          if (button.hasAttribute('data-garden-next')) this.goTo(this.activeIndex + 1);
        }, options);
        this.addEventListener('keydown', event => {
          if (event.target.closest('input,textarea,select,[contenteditable="true"]')) return;
          const destinations = { ArrowLeft: this.activeIndex - 1, ArrowRight: this.activeIndex + 1, Home: 0, End: this.slides.length - 1 };
          if (!(event.key in destinations)) return;
          event.preventDefault();
          this.goTo(destinations[event.key]);
        }, options);
        this.viewport.addEventListener('scroll', () => {
          if (this.scrollFrame) return;
          this.scrollFrame = requestAnimationFrame(() => {
            this.scrollFrame = null;
            if (!this.viewport.clientWidth) return;
            const index = Math.max(0, Math.min(this.slides.length - 1, Math.round(this.viewport.scrollLeft / this.viewport.clientWidth)));
            this.setActive(index, true);
          });
        }, { ...options, passive: true });
        document.addEventListener('shopify:block:select', event => {
          const index = this.slides.findIndex(slide => slide.dataset.blockId === String(event.detail?.blockId));
          if (index !== -1) this.goTo(index);
        }, options);
        this.resizeObserver = new ResizeObserver(() => this.goTo(this.activeIndex, false));
        this.resizeObserver.observe(this.viewport);
        this.classList.add('is-ready');
        const controls = this.querySelector('[data-garden-controls]');
        if (controls) controls.hidden = false;
        this.setActive(0, false);
      }

      goTo(index, announce = true) {
        const next = (index + this.slides.length) % this.slides.length;
        this.viewport.scrollTo({ left: next * this.viewport.clientWidth, behavior: 'instant' });
        this.setActive(next, announce);
      }

      setActive(index, announce) {
        const changed = this.activeIndex !== index;
        const previousSlide = this.slides[this.activeIndex];
        if (changed && previousSlide?.contains(document.activeElement)) this.focus({ preventScroll: true });
        this.activeIndex = index;
        this.slides.forEach((slide, position) => {
          const current = position === index;
          slide.setAttribute('aria-hidden', String(!current));
          slide.inert = !current;
          const productLink = slide.querySelector('[data-garden-product]');
          if (productLink) productLink.tabIndex = current ? 0 : -1;
        });
        if (announce && changed && this.status) this.status.textContent = this.slides[index].dataset.slideAnnouncement;
      }

      disconnectedCallback() {
        this.controller?.abort();
        this.resizeObserver?.disconnect();
        if (this.scrollFrame) cancelAnimationFrame(this.scrollFrame);
        this.controller = null;
        this.scrollFrame = null;
      }
    }
    customElements.define('lfx-garden-carousel', LfxGardenCarousel);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["lfx-welcome"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('click',function(event){const open=event.target.closest('[data-lfx-dialog-open]');if(open){const dialog=document.getElementById(open.dataset.lfxDialogOpen);if(dialog)dialog.showModal();}const close=event.target.closest('[data-lfx-dialog-close]');if(close)close.closest('dialog').close();if(event.target.matches('dialog.lfx-offer-dialog')){const rect=event.target.getBoundingClientRect();if(event.clientX<rect.left||event.clientX>rect.right||event.clientY<rect.top||event.clientY>rect.bottom)event.target.close();}});

function lfReopenWelcomeResponse(){document.querySelectorAll('.lfx-offer-dialog [data-lf-welcome-response]').forEach(function(status){const dialog=status.closest('dialog');if(dialog&&!dialog.open){dialog.showModal();status.focus();}});}
if(document.readyState==='loading'){document.addEventListener('DOMContentLoaded',lfReopenWelcomeResponse);}else{lfReopenWelcomeResponse();}
document.addEventListener('shopify:section:load',lfReopenWelcomeResponse);

  } catch(e) { console.error(e); }
})();
})();
